// eslint-disable-next-line @typescript-eslint/typedef
export const LifecycleEventsManagerEvents = {
  lifecycleEvent: 'LifecycleEventsManager.LIFECYCLE_EVENT',
  lifecycleError: 'LifecycleEventsManager.LIFECYCLE_ERROR',
};
